import ProductDetails from '../../../modules/catalog/components/product-details/containers/product-details';
import ProductCatalog from '../../../modules/catalog/components/product-catalog';

export default {
  path: ':organization/catalog',
  childRoutes: [
    {
      path: 'items',
      title: 'Items',
      component: ProductCatalog,
    },
    {
      path: 'items/:number',
      title: 'Product Details',
      component: ProductDetails,
    },
  ],
};
